/**
 * Case- and accent-insensitive substring match for location search.
 * "cafe" matches "Café", and a single leading @ is ignored so "@cafe" matches a name or a handle.
 * An empty query matches everything.
 */
export function locationTextMatches(parts: Array<string | null | undefined>, query: string): boolean {
  let needle = foldSearchText((query ?? "").trim());
  if (needle.startsWith("@")) needle = needle.slice(1);
  if (!needle) return true;
  const haystack = foldSearchText(parts.filter(part => Boolean(part)).join(" "));
  return haystack.includes(needle);
}

function foldSearchText(value: string): string {
  return value.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}
